import { subjects } from "../data/subjects";
import { groups } from "../data/groups";
import { teamSubjects } from "../data/teamSubjects";
import type { SubjectAssignment } from "../types/subject";
import type { Member } from "../types/team";
import { shuffle } from "./teams";

export const TEAM_COUNT = groups.length;

export function drawSubjects(teamCount = TEAM_COUNT): SubjectAssignment[] {
  const drawn = shuffle(subjects);
  return Array.from({ length: teamCount }, (_, i) => ({ team: i + 1, subject: drawn[i] }));
}

export const SUBJECT_STORAGE_KEY = "subject-draw-v1";

/** Official track for a group, falling back to this browser's draw result. */
export function subjectForGroup(groupId: number): string | null {
  if (teamSubjects[groupId]) return teamSubjects[groupId];
  try {
    const raw = localStorage.getItem(SUBJECT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SubjectAssignment[];
    return parsed.find((a) => a.team === groupId)?.subject ?? null;
  } catch {
    return null;
  }
}

export function groupMembers(groupId: number): Member[] {
  return groups.find((g) => g.id === groupId)?.members ?? [];
}

export function unassignedSubjects(assignments: SubjectAssignment[]): string[] {
  return subjects.filter((s) => !assignments.some((a) => a.subject === s));
}

export function assignmentsToText(assignments: SubjectAssignment[]): string {
  return assignments
    .map((a) => {
      const names = groupMembers(a.team)
        .map((m) => m.name)
        .join(", ");
      return `Group ${a.team} (${names}): ${a.subject}`; // copied as "Group N (names): Track"
    })
    .join("\n");
}
